import {
  OpenClass,
  OpenClassCertificateType,
} from '../../openClasses/types/OpenClass';
import {
  openClassOptionLabel,
  openClassesById,
} from '../../openClasses/utils/openClass';
import {
  ParticipantDraft,
  draftCertificateTypes,
  emptyParticipantDraft,
} from './openClassParticipantDraft';

export type AttendeeCsvRow = {
  name?: string;
  email?: string;
  birthDate?: string;
  birthPlace?: string;
};

export type AttendeeCsvExportRow = {
  name: string;
  email: string;
  birthDate: string;
  birthPlace: string;
  // Display labels, not wire values.
  certificateType: string;
  openClass: string;
};

export const attendeeCsvExportColumns: (keyof AttendeeCsvExportRow)[] = [
  'name',
  'email',
  'birthDate',
  'birthPlace',
  'certificateType',
  'openClass',
];

// The backend requires a name, so nameless rows are skipped. Blank lines don't count as skipped.
export const draftsFromCsvRows = (
  rows: AttendeeCsvRow[],
): { drafts: ParticipantDraft[]; skippedCount: number } => {
  const drafts: ParticipantDraft[] = [];
  let skippedCount = 0;
  rows.forEach((row) => {
    const name = row.name?.trim() ?? '';
    const email = row.email?.trim() ?? '';
    const birthDate = row.birthDate?.trim() ?? '';
    const birthPlace = row.birthPlace?.trim() ?? '';
    if (name) {
      drafts.push({
        ...emptyParticipantDraft(),
        name,
        email,
        birthDate,
        birthPlace,
      });
    } else if (email || birthDate || birthPlace) {
      skippedCount += 1;
    }
  });
  return { drafts, skippedCount };
};

export const exportRowsFromDrafts = (
  drafts: ParticipantDraft[],
  openClasses: OpenClass[],
  certificateTypeLabel: (type: OpenClassCertificateType) => string,
): AttendeeCsvExportRow[] => {
  const byId = openClassesById(openClasses);
  return drafts.map((draft) => ({
    name: draft.name,
    email: draft.email,
    birthDate: draft.birthDate,
    birthPlace: draft.birthPlace,
    certificateType: draftCertificateTypes(draft)
      .map(certificateTypeLabel)
      .join('; '),
    openClass: draft.registrations
      .map(({ openClassId }) => {
        const openClass = byId.get(openClassId);
        return openClass ? openClassOptionLabel(openClass) : '–';
      })
      .join('; '),
  }));
};
